var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{key:_vm.$route.fullPath}),_c('div',{staticStyle:{"padding-top":"66px"}},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }